const UrlConfig = {
  HOME: `/`,
  LOGIN: `/login`,
  FAQS: `/faqs`,
  CLIENT_FAQS: `/faqs/client-faqs`,
  SUGGESTIONS: `/chat/suggestions`,
  PLAYGROUND: `/chat/playground`,
  CHAT_BOT_SETTINGS: `/chat/settings`,
  GROK_RAG: `/chat/grok-rag`,
  AI_WORKSPACE: `/ai-workspace`,
  WEBSITE_BUILDER: `/website-builder`,
  PRICE_SHEET: `/price-sheet`,
  GOOGLE_ADS_HOURLY_COC: `/google-ads/hourly-coc`,
  GOOGLE_ADS_HIGHEST_COST_KEYWORDS: `/google-ads/highest-cost-keywords`,
  GOOGLE_ADS_LOWEST_CONV_KEYWORDS: `/google-ads/lowest-conv-keywords`,
};

export default UrlConfig;
